import React from 'react';
import EditorialLayout from '@/components/editorial/EditorialLayout';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Clock, Send, Eye } from 'lucide-react';

const PublishingQueuePage: React.FC = () => {
  return (
    <EditorialLayout>
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="mb-8">
          <h1 className="text-3xl font-bold mb-2">Publishing Queue</h1>
          <p className="text-gray-600">Manage content scheduled for publication</p>
        </div>

        <div className="grid gap-6">
          {/* Queue Statistics */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
            <Card>
              <CardHeader className="pb-2">
                <CardTitle className="text-lg flex items-center gap-2">
                  <Clock className="h-5 w-5" />
                  Pending
                </CardTitle>
              </CardHeader>
              <CardContent>
                <div className="text-2xl font-bold">12</div>
                <p className="text-sm text-gray-600">Items waiting to publish</p>
              </CardContent>
            </Card>
            
            <Card>
              <CardHeader className="pb-2">
                <CardTitle className="text-lg flex items-center gap-2">
                  <Send className="h-5 w-5" />
                  Scheduled
                </CardTitle>
              </CardHeader>
              <CardContent>
                <div className="text-2xl font-bold">8</div>
                <p className="text-sm text-gray-600">Items scheduled for later</p>
              </CardContent>
            </Card>
            
            <Card>
              <CardHeader className="pb-2">
                <CardTitle className="text-lg flex items-center gap-2">
                  <Eye className="h-5 w-5" />
                  Under Review
                </CardTitle>
              </CardHeader>
              <CardContent>
                <div className="text-2xl font-bold">5</div>
                <p className="text-sm text-gray-600">Items being reviewed</p>
              </CardContent>
            </Card>
          </div>

          {/* Queue Items */}
          <Card>
            <CardHeader>
              <CardTitle>Queue Items</CardTitle>
              <CardDescription>Content waiting to be published</CardDescription>
            </CardHeader>
            <CardContent>
              <div className="space-y-4">
                {/* Sample queue items */}
                <div className="flex items-center justify-between p-4 border rounded-lg">
                  <div className="flex-1">
                    <h3 className="font-semibold">Interview with Tech CEO</h3>
                    <p className="text-sm text-gray-600">Scheduled for tomorrow at 10:00 AM</p>
                    <div className="flex gap-2 mt-2">
                      <Badge variant="secondary">Interview</Badge>
                      <Badge variant="outline">Tech</Badge>
                    </div>
                  </div>
                  <div className="flex gap-2">
                    <Button variant="outline" size="sm">Edit</Button>
                    <Button size="sm">Publish Now</Button>
                  </div>
                </div>

                <div className="flex items-center justify-between p-4 border rounded-lg">
                  <div className="flex-1">
                    <h3 className="font-semibold">Marketing Strategy Article</h3>
                    <p className="text-sm text-gray-600">Under review - pending approval</p>
                    <div className="flex gap-2 mt-2">
                      <Badge variant="secondary">Article</Badge>
                      <Badge variant="outline">Marketing</Badge>
                    </div>
                  </div>
                  <div className="flex gap-2">
                    <Button variant="outline" size="sm">Review</Button>
                    <Button variant="outline" size="sm">Schedule</Button>
                  </div>
                </div>

                <div className="flex items-center justify-between p-4 border rounded-lg">
                  <div className="flex-1">
                    <h3 className="font-semibold">Product Launch Update</h3>
                    <p className="text-sm text-gray-600">Ready to publish</p>
                    <div className="flex gap-2 mt-2">
                      <Badge variant="secondary">News</Badge>
                      <Badge variant="outline">Product</Badge>
                    </div>
                  </div>
                  <div className="flex gap-2">
                    <Button variant="outline" size="sm">Edit</Button>
                    <Button size="sm">Publish</Button>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </EditorialLayout>
  );
};

export default PublishingQueuePage;